import React from 'react';
import useWithStore from "@/Hooks/useWithStore";
import CatalogCard from "@/Components/Site/CatalogCard";
import isEmpty from "is-empty";
import {isDesktop, isMobile} from "@/Helpers/Function";
import Link from "@/Layouts/Link";
import Svg from "@/Components/Svg";
import {withViewItemBatcher} from "@/Context/ViewItemBatcherContext";
import '@/Pages/Collections/scss/pets.scss';

class Pets extends React.Component {
    constructor(props) {
        super(props);
        this.videoRefFirst = React.createRef();
        this.videoRefSecond = React.createRef();
        this.videoRefThird = React.createRef();
    }

    state = {
        videoSvgThird: false,
        videoPlayPauseFlagThird: true,
        videoVolumeSvgThird: true,
        videoSvgFirst: true,
        videoSvgSecond: true,
        firstVideoPlayPauseFlag: true,
        secondVideoPlayPauseFlag: true,
        firstVideoVolumeSvg: true,
        secondVideoVolumeSvg: true,
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.videoRefThird.current !== null) {
            const videoThird = this.videoRefThird.current;
            videoThird.onended = (e) => {
                videoThird.muted = true;
                this.setState({
                    videoSvgThird: true,
                    videoVolumeSvgThird: true
                })
            };
        }
        if (this.videoRefFirst.current !== null) {
            const firstVideo = this.videoRefFirst.current;
            firstVideo.onended = (e) => {
                firstVideo.muted = true;
                this.setState({
                    videoSvgFirst: true,
                    firstVideoVolumeSvg: true
                })
            };
        }
        if (this.videoRefSecond.current !== null) {
            const secondVideo = this.videoRefSecond.current;
            secondVideo.onended = (e) => {
                secondVideo.muted = true;
                this.setState({
                    videoSvgSecond: true,
                    secondVideoVolumeSvg: true
                })
            };
        }
    }

    videoTimerThird = () => setTimeout(() => {
        this.setState({videoPlayPauseFlagThird: false})
    }, 3000);

    firstVideoTimer = () => setTimeout(() => {
        this.setState({firstVideoPlayPauseFlag: false})
    }, 3000);

    secondVideoTimer = () => setTimeout(() => {
        this.setState({secondVideoPlayPauseFlag: false})
    }, 3000);

    /**
     * Управление звуком
     */
    mediaChangeVolumeThird = () => {
        try {
            const video = this.videoRefThird.current;
            if (video.muted) {
                video.muted = false;
                this.setState({videoVolumeSvgThird: false})
            } else {
                video.muted = true;
                this.setState({videoVolumeSvgThird: true})
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Управление звуком
     */
    mediaChangeVolumeFirst = () => {
        try {
            const video = this.videoRefFirst.current;
            if (video.muted) {
                video.muted = false;
                this.setState({firstVideoVolumeSvg: false})
            } else {
                video.muted = true;
                this.setState({firstVideoVolumeSvg: true})
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Управление звуком
     */
    mediaChangeVolumeSecond = () => {
        try {
            const video = this.videoRefSecond.current;
            if (video.muted) {
                video.muted = false;
                this.setState({secondVideoVolumeSvg: false})
            } else {
                video.muted = true;
                this.setState({secondVideoVolumeSvg: true})
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Убираем кнопку паузы на мобилке
     */
    mediaChangePlayPauseThird = () => {
        try {
            if (!isDesktop()) {
                clearInterval(this.videoTimerThirdId);
                if (!this.state.videoPlayPauseFlagThird) {
                    this.setState({videoPlayPauseFlagThird: true})
                }
                this.videoTimerThirdId = this.videoTimerThird();
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Убираем кнопку паузы на мобилке
     */
    mediaChangePlayPauseFirst = () => {
        try {
            if (!isDesktop()) {
                clearInterval(this.firstVideoTimerId);
                if (!this.state.firstVideoPlayPauseFlag) {
                    this.setState({firstVideoPlayPauseFlag: true})
                }
                this.firstVideoTimerId = this.firstVideoTimer();
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Убираем кнопку паузы на мобилке
     */
    mediaChangePlayPauseSecond = () => {
        try {
            if (!isDesktop()) {
                clearInterval(this.secondVideoTimerId);
                if (!this.state.secondVideoPlayPauseFlag) {
                    this.setState({secondVideoPlayPauseFlag: true})
                }
                this.secondVideoTimerId = this.secondVideoTimer();
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Воспроизведение / пауза видео
     */
    mediaChangeThird = () => {
        try {
            const video = this.videoRefThird.current;
            if (video !== null) {
                if (video.paused) {
                    video.play();
                    this.setState({videoSvgThird: false})
                } else {
                    video.pause();
                    this.setState({videoSvgThird: true})
                }
                video.onended = (e) => {
                    this.setState({videoSvgThird: true})
                };
            }
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Воспроизведение / пауза видео
     */
    mediaChangeFirst = () => {
        try {
            const video = this.videoRefFirst.current;
            if (video.paused) {
                video.play();
                this.setState({videoSvgFirst: false})
            } else {
                video.pause();
                this.setState({videoSvgFirst: true})
            }
            video.onended = (e) => {
                this.setState({videoSvgFirst: true})
            };
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Воспроизведение / пауза видео
     */
    mediaChangeSecond = () => {
        try {
            const video = this.videoRefSecond.current;
            if (video.paused) {
                video.play();
                this.setState({videoSvgSecond: false})
            } else {
                video.pause();
                this.setState({videoSvgSecond: true})
            }
            video.onended = (e) => {
                this.setState({videoSvgSecond: true})
            };
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Логотип коллекции
     * @param dataPets
     * @returns {JSX.Element|null}
     */
    logo = (dataPets) => {
        try {
            if (isEmpty(dataPets)) {
                return null;
            }

            return <div className={`logoPets`}>
                <picture>
                    <source type={`image/webp`}
                            srcSet={dataPets.logoPathWebp}
                    />
                    <img src={dataPets.logoPath}
                         alt={`Logo`}
                         loading={`lazy`}
                         width={`350`}
                         height={`99`}
                    />
                </picture>
            </div>
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Видео
     * @param dataPets
     * @param state
     * @returns {JSX.Element}
     */
    firstVideo = (dataPets, state) => {
        try {
            if (isEmpty(dataPets)) {
                return null;
            }

            const source = dataPets.videoSource.map((el) => {
                return <source key={el.id}
                               src={isMobile() ? el.pathMobile : el.pathDesktop}
                               type={el.type} />
            });

            return <div className={`pets-wrapper__video-main`}>
                <video ref={this.videoRefFirst}
                       autoPlay={dataPets.autoPlay}
                       muted={`muted`}
                       preload={`none`}
                       width={`100%`}
                       poster={isMobile() ? dataPets.videoPosterMobile : dataPets.videoPosterDesktop}
                >
                    {source}
                </video>
                <div className={`video-control`} onClick={() => this.mediaChangePlayPauseFirst()}>
                    {state.videoSvgFirst ?
                        <div className={`gg-play-button`} onClick={() => this.mediaChangeFirst()}></div>
                        :
                        <>
                            {state.firstVideoPlayPauseFlag && (
                                <div className={`gg-pause-button`} onClick={() => this.mediaChangeFirst()}></div>
                            )}
                        </>
                    }
                    <div className={`volume`} onClick={() => this.mediaChangeVolumeFirst()}>
                        {state.firstVideoVolumeSvg ?
                            <Svg id={`volumeOffOutlinedIcon`} className={`svg__muted-off`} />
                            :
                            <Svg id={`volumeDownOutlinedIcon`} className={`svg__muted-on`} />
                        }
                    </div>
                </div>
            </div>
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Видео
     * @param dataPets
     * @param state
     * @returns {JSX.Element}
     */
    secondVideo = (dataPets, state) => {
        try {
            if (isEmpty(dataPets)) {
                return null;
            }

            const source = dataPets.videoSource.map((el) => {
                return <source key={el.id}
                               src={isMobile() ? el.pathMobile : el.pathDesktop}
                               type={el.type} />
            });

            return <div className={`pets-wrapper__video-main`}>
                <video ref={this.videoRefSecond}
                       autoPlay={dataPets.autoPlay}
                       muted={`muted`}
                       preload={`none`}
                       width={`100%`}
                       poster={isMobile() ? dataPets.videoPosterMobile : dataPets.videoPosterDesktop}
                >
                    {source}
                </video>
                <div className={`video-control`} onClick={() => this.mediaChangePlayPauseSecond()}>
                    {state.videoSvgSecond ?
                        <div className={`gg-play-button`} onClick={() => this.mediaChangeSecond()}></div>
                        :
                        <>
                            {state.secondVideoPlayPauseFlag && (
                                <div className={`gg-pause-button`} onClick={() => this.mediaChangeSecond()}></div>
                            )}
                        </>
                    }
                    <div className={`volume`} onClick={() => this.mediaChangeVolumeSecond()}>
                        {state.secondVideoVolumeSvg ?
                            <Svg id={`volumeOffOutlinedIcon`} className={`svg__muted-off`} />
                            :
                            <Svg id={`volumeDownOutlinedIcon`} className={`svg__muted-on`} />
                        }
                    </div>
                </div>
            </div>
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Видео
     * @param dataPets
     * @param state
     * @returns {JSX.Element|null}
     */
    thirdVideo = (dataPets, state) => {
        try {
            if (isEmpty(dataPets)) {
                return null;
            }

            const source = dataPets.videoSource.map((el) => {
                return <source key={el.id}
                               src={isMobile() ? el.pathMobile : el.pathDesktop}
                               type={el.type} />
            });

            return <div className={`pets-wrapper__video-main`}>
                <video ref={this.videoRefThird}
                       autoPlay={dataPets.autoPlay}
                       muted={`muted`}
                       preload={`none`}
                       width={`100%`}
                       poster={isMobile() ? dataPets.videoPosterMobile : dataPets.videoPosterDesktop}
                >
                    {source}
                </video>
                <div className={`video-control`} onClick={() => this.mediaChangePlayPauseThird()}>
                    {state.videoSvgThird ?
                        <div className={`gg-play-button`} onClick={() => this.mediaChangeThird()}></div>
                        :
                        <>
                            {state.videoPlayPauseFlagThird && (
                                <div className={`gg-pause-button`} onClick={() => this.mediaChangeThird()}></div>
                            )}
                        </>
                    }
                    <div className={`volume`} onClick={() => this.mediaChangeVolumeThird()}>
                        {state.videoVolumeSvgThird ?
                            <Svg id={`volumeOffOutlinedIcon`} className={`svg__muted-off`} />
                            :
                            <Svg id={`volumeDownOutlinedIcon`} className={`svg__muted-on`} />
                        }
                    </div>
                </div>
            </div>
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * H1 и description
     * @param dataPets
     * @returns {JSX.Element}
     */
    text = (dataPets) => {
        try {
            if (isEmpty(dataPets) || isEmpty(dataPets.h1) || isEmpty(dataPets.description)) {
                return null;
            }
            return <>
                <h1 className={`h1 h1__pets`}>
                    {dataPets.h1}
                </h1>
                {dataPets.description.map((el, i) => {
                    return <p key={i}
                              className={`pets-wrapper__description`}>
                        {el}
                    </p>
                })}
            </>
        } catch (e) {
            console.log('e', e);
        }
    }

    /**
     * Sets
     * @param dataPets
     * @param registerView
     * @returns {null|*}
     */
    sets = (dataPets, registerView) => {
        try {
            if (isEmpty(dataPets)) {
                return null;
            }
            let cardList = [], offset = 0;
            return dataPets.sets.map((el) => {
                cardList = el.dataCardSet.map((product, i) => {
                    return <CatalogCard
                        key={product.id}
                        el={product}
                        {...this.props}
                        index={offset + i + 1}
                        registerView={registerView}
                    />
                })
                offset += el.dataCardSet.length;

                return <div key={el.id} className={`pets-wrapper__set`}>
                    <picture>
                        {el.pictureSource.map((el) => {
                            return <source key={el.id}
                                           type={el.type}
                                           srcSet={el.path}
                                           media={el.media}
                            />
                        })}
                        <img src={el.picturePath}
                             alt={el.pictureAlt}
                             loading={`lazy`}
                             width={isMobile() ? "768" : "1500"}
                             height={isMobile() ? "768" : "624"}
                        />
                    </picture>
                    <div className={`cardWrapper`}>
                        {cardList}
                    </div>
                </div>
            });
        } catch (e) {
            console.log('e', e);
        }
    }

    render() {
        const {collectionDetailedData = {}, registerView} = this.props;

        return <section className={`section`}>
            <div className={`collections-lp`}>
                <div className={`container`}>
                    {this.logo(collectionDetailedData.dataPetsFirst)}
                    <div className={`pets-wrapper`}>
                        {this.thirdVideo(collectionDetailedData.dataPetsThird, this.state)}
                        {this.text(collectionDetailedData.dataPetsThird)}
                        {this.sets(collectionDetailedData.dataPetsThird)}
                        {this.firstVideo(collectionDetailedData.dataPetsFirst, this.state)}
                        {this.sets(collectionDetailedData.dataPetsFirst)}
                        {this.secondVideo(collectionDetailedData.dataPetsSecond, this.state)}
                        {this.sets(collectionDetailedData.dataPetsSecond, registerView)}
                        <Link href={`/catalog/platina-pets`} className={`btn btn__pets`}>Все украшения</Link>
                    </div>
                </div>
            </div>
        </section>
    }
}

export default withViewItemBatcher(useWithStore(Pets));
